import { mapState } from 'vuex';
export default {
  name: 'CoreDrawerItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('app', ['color', 'miniVariant'])
  },
  methods: {
    i18nFromKey(key) {
      return this.$i18n_t(key);
    }
  }
};